









































































import { Component, Vue, Prop, Watch, Inject } from "vue-property-decorator";
import { DataPoint, HSL, Name, NameData } from "../models";
import GenderIcon from "../components/GenderIcon.vue";
import NameStreamGraph from "../components/NameStreamGraph.vue";
import VueSwing from "vue-swing/VueSwing.vue";
import { mdiChevronDown } from "@mdi/js";
@Component({
  components: {
    GenderIcon,
    NameStreamGraph
  },
  mounted() {
    const { id, gender, mode, otherID } = this.$route.params;
    this.$data.otherKindlingID = otherID || "";
    fetch(`${process.env.VUE_APP_API_ROOT}/kindling/id/${id}/matches/?limit=5`)
      .then(res => res.json())
      .then(data => {
        const { nameData, numberOfParticipants } = data;
        this.$data.names = nameData;
        this.$data.participants = numberOfParticipants;
      });
    fetch(`${process.env.VUE_APP_API_ROOT}/minmax-years`)
      .then(res => res.json())
      .then((data: any) => {
        const { minYear, maxYear } = data;
        this.$data.minYear = minYear;
        this.$data.maxYear = maxYear;
      });
  }
})
export default class Matches extends Vue {
  names: NameData[] = [];
  @Prop({ default: 1 }) participants: number;

  expanded = "";
  setExpanded(key: string) {
    this.expanded = this.expanded === key ? "" : key;
  }

  otherKindlingID = "";

  mdiChevronDown = mdiChevronDown;

  minYear = 2010;
  maxYear = 2015;

  nameData: Map<string, DataPoint[]> = new Map();

  toNameCase(name: string) {
    return name
      .split("-")
      .map(
        (namePart: string) =>
          `${namePart[0].toUpperCase()}${namePart.slice(1).toLowerCase()}`
      )
      .join("-");
  }

  get items() {
    return this.names.map(nameData => ({
      ...nameData,
      key: `${nameData.name}${nameData.gender}`,
      mostRecentYear: this.getMostRecentYear(
        this.nameData.get(`${nameData.name}${nameData}`)
      )
    }));
  }

  getMostRecentYear(datapoints: DataPoint[]) {
    if (!datapoints)
      return { year: undefined, count: undefined, rank: undefined };

    const sortedYears = datapoints.sort((a, b) => (a.year < b.year ? 1 : -1));
    return sortedYears[0];
  }

  @Watch("names")
  onNamesChange(newNames: NameData[], oldNames: NameData[]) {
    newNames.forEach(name => {
      const thisName =
        oldNames.find(n => n.name === name.name && n.gender === name.gender) ||
        name;

      if (!thisName || !thisName.data) {
        fetch(
          `${process.env.VUE_APP_API_ROOT}/births/${name.name}/gender/${name.gender}`
        )
          .then(res => res.json())
          .then(js => {
            this.nameData.set(`${name.name}${name.gender}`, js);
          });
      }
    });
  }

  @Watch("otherKindlingID")
  onOtherKindlingIDChange(otherID: string) {
    const { id } = this.$route.params;
    fetch(
      `${process.env.VUE_APP_API_ROOT}/kindling/id/${id}/matches/${otherID}/?limit=5`
    )
      .then(res => res.json())
      .then(data => {
        const { nameData, numberOfParticipants } = data;
        this.names = nameData;
        this.participants = numberOfParticipants;
        if (numberOfParticipants === 2)
          localStorage.setItem("baby-names-kindling-otherID", otherID);
      });
  }
}
